angular.module('charting').filter('forChart', function($filter) {
    return function(data, query, disableLegendUpdate, colors, sizes, lines, valuesField) {
        return $filter('forChartWidget')(data, query.unit.selectedUnit, query.time, query.subject, disableLegendUpdate, colors, sizes, lines, valuesField);
    }
});